import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'cs0001',
    ecrans: ['00-2'],
    params: ['?demcleint', '?acccleint', '?dalcleint']
});
